import * as React from "react";

const NoProductFoundIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="124"
    height="139"
    fill="none"
    viewBox="0 0 124 139"
  >
    <g clipPath="url(#clip0_4915_82178)">
      <path
        fill="#EFEFEF"
        d="M70.42 29.886h47.181a3.753 3.753 0 0 0 3.753-3.753V3.753A3.753 3.753 0 0 0 117.601 0h-47.18a3.753 3.753 0 0 0-3.754 3.753v22.38a3.753 3.753 0 0 0 3.753 3.753M4.567 93.47h64.721a3.753 3.753 0 0 0 3.753-3.753v-22.38a3.753 3.753 0 0 0-3.753-3.753H4.568a3.753 3.753 0 0 0-3.754 3.753v22.38a3.753 3.753 0 0 0 3.753 3.753"
      ></path>
      <path
        fill="#EFEFEF"
        d="M13.25 53.81H69.2a3.753 3.753 0 0 0 3.753-3.752v-22.38a3.753 3.753 0 0 0-3.753-3.753H13.25a3.753 3.753 0 0 0-3.753 3.753v22.38a3.753 3.753 0 0 0 3.753 3.752M41.942 138.843h40.165a3.753 3.753 0 0 0 3.752-3.753v-22.38a3.753 3.753 0 0 0-3.752-3.753H41.942a3.753 3.753 0 0 0-3.752 3.753v22.38a3.753 3.753 0 0 0 3.752 3.753M79.27 102.511h40.165a3.753 3.753 0 0 0 3.753-3.753v-22.38a3.753 3.753 0 0 0-3.753-3.753H79.27a3.753 3.753 0 0 0-3.752 3.753v22.38a3.753 3.753 0 0 0 3.752 3.753"
      ></path>
      <path fill="#fff" d="M106.762 11.938h-80.19v20.206h80.19z"></path>
      <path
        fill="#BCBEC0"
        d="M106.762 30.5H29.864c-1.025 0-2.129-.119-3.149 0-.046.005-.096 0-.143 0l1.645 1.644V11.937l-1.645 1.644h76.899c1.024 0 2.128.119 3.148 0 .047-.005.097 0 .143 0l-1.644-1.644v20.206c0 2.117 3.289 2.12 3.289 0V11.937c0-.89-.754-1.645-1.645-1.645H36.466c-3.24 0-6.513-.137-9.75 0q-.073.002-.144 0c-.89 0-1.644.754-1.644 1.645v20.206c0 .89.753 1.645 1.644 1.645h70.296c3.24 0 6.513.137 9.751 0q.072-.002.143 0c2.116 0 2.12-3.288 0-3.288"
      ></path>
      <path
        fill="#fff"
        d="m82.514 52.351-6.57 49.008-13.919 15.654L50.82 52.351 26.572 32.145h80.19z"
      ></path>
      <path
        fill="#BCBEC0"
        d="m80.87 52.351-2.213 16.505q-1.771 13.221-3.545 26.442l-.812 6.061.482-1.163q-6.082 6.838-12.163 13.68l-1.757 1.975 2.75.726-2.275-13.123-4.664-26.919-3.745-21.614c-.185-1.066-.154-2.925-.975-3.759-.557-.566-1.25-1.042-1.86-1.55l-4.098-3.415-17.88-14.9-.38-.316-1.162 2.807h76.898c1.026 0 2.127.114 3.149 0 .046-.005.096 0 .143 0l-1.163-2.807-21.246 17.705-3.002 2.502c-1.628 1.357.71 3.672 2.325 2.326l21.246-17.705 3.002-2.502c1.131-.942.175-2.808-1.162-2.808H36.466c-3.24 0-6.513-.136-9.75 0q-.072.001-.143 0c-1.33 0-2.295 1.864-1.163 2.808q7.89 6.573 15.777 13.148l7.798 6.498c.181.15.415.437.635.529.112.047-.358-1.06-.361-.558-.004.515.19 1.1.278 1.605l3.442 19.865 4.694 27.086 1.805 10.416c.305 1.763.526 3.568.92 5.314.018.079.029.16.043.24.208 1.204 1.97 1.601 2.748.726l10.18-11.451c1.235-1.387 2.606-2.728 3.737-4.202.645-.84.636-2.298.773-3.33l4.73-35.276q.773-5.783 1.55-11.566c.118-.881-.84-1.644-1.645-1.644-.986 0-1.525.76-1.644 1.644"
      ></path>
      <path
        fill="#FFE6CB"
        d="M91.35 118.344c10.113 0 18.31-8.198 18.31-18.31s-8.197-18.31-18.31-18.31c-10.111 0-18.309 8.198-18.309 18.31s8.198 18.31 18.31 18.31"
      ></path>
      <path
        fill="#D8C6B8"
        d="M108.017 100.033c-.057 6.889-4.378 13.311-10.927 15.657-6.683 2.393-14.163.316-18.681-5.145-4.428-5.351-4.895-13.218-1.323-19.128 3.57-5.91 10.665-9.113 17.446-7.75 7.789 1.567 13.42 8.437 13.485 16.367.018 2.116 3.307 2.121 3.289 0-.069-8.33-5.269-15.791-13.067-18.727-7.788-2.932-16.983-.427-22.245 6.002-5.3 6.475-6.096 15.799-1.747 23.003 4.348 7.204 12.917 10.912 21.16 9.261 9.207-1.845 15.823-10.239 15.899-19.539.018-2.117-3.271-2.119-3.289 0z"
      ></path>
      <path
        fill="#D8C6B8"
        d="M98.645 90.416 83.839 105.22l-2.107 2.107c-1.499 1.499.826 3.825 2.326 2.326l14.806-14.806 2.106-2.107c1.499-1.498-.826-3.824-2.325-2.326"
      ></path>
      <path
        fill="#D8C6B8"
        d="m81.732 92.742 14.806 14.805 2.106 2.107c1.499 1.499 3.825-.826 2.326-2.326L86.164 92.522l-2.106-2.106c-1.499-1.5-3.825.826-2.326 2.326"
      ></path>
      <path
        stroke="#BCBEC0"
        strokeMiterlimit="10"
        strokeWidth="0.877"
        d="M106.762 22.041H101.5"
      ></path>
      <path
        stroke="#BCBEC0"
        strokeDasharray="11 9.17"
        strokeMiterlimit="10"
        strokeWidth="0.877"
        d="M92.334 22.041H36.418"
      ></path>
      <path
        stroke="#BCBEC0"
        strokeMiterlimit="10"
        strokeWidth="0.877"
        d="M31.834 22.041h-5.262"
      ></path>
    </g>
    <defs>
      <clipPath id="clip0_4915_82178">
        <path fill="#fff" d="M.814 0h122.372v138.842H.814z"></path>
      </clipPath>
    </defs>
  </svg>
);

export default NoProductFoundIcon;
